import { render, staticRenderFns } from "./PasswordChangeModal.vue?vue&type=template&id=50505f88&scoped=true&"
import script from "./PasswordChangeModal.vue?vue&type=script&lang=ts&"
export * from "./PasswordChangeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordChangeModal.vue?vue&type=style&index=0&id=50505f88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50505f88",
  null
  
)

export default component.exports